module.exports = __webpack_public_path__ + "static/scale-model-of-thanks-giving-square-in-dallas-texas-9c254c1756b11c168df66d805d114d2d.png";